module.exports = __webpack_public_path__ + "img/vierge.c61b0174.svg";